export default __webpack_public_path__ + "5678b1fe23c2d861c13e7e15796d7d91.png";